import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUsersData,
  registerUser,
  fetchUpdateUser,
  fetchDeleteUser,
  updateOnBoardingStatus,
} from './adminAPI';
import { toast } from 'react-toastify';

export const initialState = {
  userData: { data: [], error: '', loading: !false },
  createUser: { success: false, error: '', loading: false },
  updateUser: { success: false, error: '', loading: false },
  deleteUser: { success: false, error: '', loading: false },
  userEnteredData: {},
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState: initialState,
  reducers: {
    setCreateSuccess: (state, action) => {
      state.createUser.success = action.payload;
    },
    setCreateError: (state, action) => {
      state.createUser.error = action.payload;
    },
    setUpdateUserSucess: (state, action) => {
      state.updateUser.success = action.payload;
    },
    setUpdateUserError: (state, action) => {
      state.updateUser.error = action.payload;
    },
    setUserEnterData: (state, action) => {
      state.userEnteredData = action.payload;
    },
    setDeleteUserSucess: (state, action) => {
      state.deleteUser.success = action.payload;
    },
    setDeleteUserError: (state, action) => {
      state.deleteUser.error = action.payload;
    },
  },
  extraReducers: {
    [fetchUsersData.pending]: (state) => {
      state.userData.loading = true;
    },
    [fetchUsersData.rejected]: (state, { meta, error }) => {
      state.userData.loading = false;
      state.userData.data = [];
      state.userData.error = error;
    },
    [fetchUsersData.fulfilled]: (state, { meta, payload: { data } }) => {
      state.userData.loading = false;
      state.userData.error = '';
      state.userData.data = data;
    },

    [registerUser.pending]: (state) => {
      console.log('pending state => ', state);
      state.createUser.loading = true;
    },
    [registerUser.rejected]: (state, { meta, error, errors, payload }) => {
      console.log('rejected state => ', state);
      state.createUser.success = false;
      state.createUser.loading = false;
      state.createUser.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
    },
    [registerUser.fulfilled]: (state, { meta, payload: { data } }) => {
      console.log('fulfilled state => ', state);
      state.createUser.success = true;
      state.createUser.loading = false;
      state.createUser.error = '';
    },

    [fetchUpdateUser.pending]: (state) => {
      state.updateUser.loading = true;
    },
    [fetchUpdateUser.rejected]: (state, { meta, error, errors, payload }) => {
      state.updateUser.loading = false;
      state.updateUser.success = false;
      state.updateUser.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
    },
    [fetchUpdateUser.fulfilled]: (state, { meta, payload: { data } }) => {
      state.updateUser.loading = false;
      state.updateUser.error = '';
      state.updateUser.success = true;
    },

    [fetchDeleteUser.pending]: (state) => {
      state.deleteUser.loading = true;
    },
    [fetchDeleteUser.rejected]: (state, { meta, error, errors, payload }) => {
      state.deleteUser.loading = false;
      state.deleteUser.success = false;
      state.deleteUser.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
    },
    [fetchDeleteUser.fulfilled]: (state, { meta, payload: { data } }) => {
      state.deleteUser.loading = false;
      state.deleteUser.error = '';
      state.deleteUser.success = true;
    },
    [updateOnBoardingStatus.pending]: (state) => {},
    [updateOnBoardingStatus.rejected]: (
      state,
      { meta, error, errors, payload }
    ) => {},
    [updateOnBoardingStatus.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {},
  },
});

export const {
  setCreateSuccess,
  setCreateError,
  setUpdateUserSucess,
  setUpdateUserError,
  setUserEnterData,
  setDeleteUserSucess,
  setDeleteUserError,
} = adminSlice.actions;

export default adminSlice.reducer;
